import { Card, CardContent } from "@/components/ui/card";
import { CircleCheck, TriangleAlert } from "lucide-react";
export default function RemindersAndWarnings() {
  return <section id="promemoria-e-avvertenze" className="bg-muted/30 py-12 md:py-16">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {}
          <Card className="group hover:shadow-md transition-all duration-300 border-l-4 border-l-primary">
            <CardContent className="p-6 flex gap-4 items-start">
              <div className="shrink-0 mt-1">
                <CircleCheck className="size-8 text-primary" />
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="font-default text-xl font-bold text-foreground">
                  RICORDA
                </h3>
                <ul className="space-y-2 text-muted-foreground">
                  <li className="flex items-start gap-2">
                    <span className="text-primary font-bold mt-0.5">•</span>
                    <span>
                      Puoi fare una X solo sul Sindaco oppure una X solo sulla
                      lista.
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary font-bold mt-0.5">•</span>
                    <span>
                      Oppure puoi fare una X sul Sindaco e una X sulla lista
                      collegata.
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary font-bold mt-0.5">•</span>
                    <span>Il voto è valido in tutti i casi.</span>
                  </li>
                </ul>
              </div>
            </CardContent>
          </Card>

          {}
          <Card className="group hover:shadow-md transition-all duration-300 border-l-4 border-l-secondary bg-secondary/5">
            <CardContent className="p-6 flex gap-4 items-start">
              <div className="shrink-0 mt-1">
                <TriangleAlert className="size-8 fill-secondary text-secondary-foreground" />
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="font-default text-xl font-bold text-foreground">
                  ATTENZIONE
                </h3>
                <p className="text-muted-foreground">
                  Non fare segni su più liste: il voto alla lista verrebbe
                  annullato.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}